var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotSelectedStar = function SvgNotSelectedStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20746 2.43917C8.45746 1.67167 9.54329 1.67167 9.79246 2.43917L11.0583 6.33417C11.1128 6.50124 11.2187 6.64682 11.3609 6.75009C11.503 6.85336 11.6742 6.90904 11.85 6.90917H15.9458C16.7533 6.90917 17.0883 7.9425 16.4358 8.4175L13.1225 10.8242C12.9801 10.9276 12.8742 11.0735 12.8199 11.2409C12.7655 11.4082 12.7656 11.5885 12.82 11.7558L14.085 15.6508C14.335 16.4192 13.4558 17.0575 12.8033 16.5825L9.48996 14.1758C9.34755 14.0723 9.17602 14.0166 8.99996 14.0166C8.8239 14.0166 8.65236 14.0723 8.50996 14.1758L5.19662 16.5825C4.54412 17.0575 3.66496 16.4183 3.91496 15.6508L5.17996 11.7558C5.23436 11.5885 5.23439 11.4082 5.18005 11.2409C5.12571 11.0735 5.01978 10.9276 4.87746 10.8242L1.56412 8.4175C0.910791 7.9425 1.24746 6.90917 2.05412 6.90917H6.14912C6.325 6.90921 6.49638 6.85361 6.63873 6.75033C6.78108 6.64705 6.8871 6.50137 6.94162 6.33417L8.20746 2.43917V2.43917Z",
    stroke: "#6B7280",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotSelectedStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/not-selected-star.1c879ecf.svg";
export { ForwardRef as ReactComponent };